export const CONTACT_UPDATE_STAGES = {
  INITIAL: 'initial',
  CONFIRMATION: 'confirmation',
  EMAIL: 'email',
  SUCCESS: 'success',
}
